function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 14.138H2.475c-.3 0-.525.225-.525.525V16.2c0 .3.225.525.525.525H13.8c.337 0 .637-.3.637-.637v-1.313c-.037-.375-.3-.637-.637-.637zM.525 13.387H11.85c.338 0 .638-.3.638-.637v-1.313c0-.337-.3-.637-.638-.637H.525c-.3 0-.525.225-.525.525v1.537c0 .263.225.525.525.525zM11.813 17.438H.524c-.3 0-.525.225-.525.524V19.5c0 .3.225.525.525.525H11.85c.338 0 .638-.3.638-.637v-1.313c-.038-.337-.3-.637-.675-.637zM6.225 10.238c2.775 0 5.063-2.288 5.063-5.138 0-2.812-2.25-5.1-5.063-5.1C3.45 0 1.163 2.288 1.163 5.1c0 2.813 2.287 5.138 5.062 5.138zM5.1 2.138h.75v-.675c0-.188.15-.376.375-.376.188 0 .375.188.375.375v.676h1.5a.376.376 0 010 .75h-3c-.487 0-.9.412-.9.9 0 .525.413.937.9.937h2.25c.9 0 1.65.75 1.65 1.688C9 7.35 8.25 8.1 7.35 8.1H6.6v.675a.403.403 0 01-.375.375.376.376 0 01-.375-.375V8.1h-1.5a.376.376 0 01-.375-.375c0-.188.188-.375.375-.375h3c.488 0 .9-.412.9-.938 0-.524-.412-.937-.9-.937H5.1c-.9 0-1.65-.75-1.65-1.687 0-.9.75-1.65 1.65-1.65z",
  fill: "#B0B8CE"
});

function SvgOrderBookUnactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    fill: "none"
  }, props), _ref);
}

export default SvgOrderBookUnactive;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/orderBook_unactive.svg
// module id = 1328
// module chunks = 10